import sect1_left from '../../../../assets/images/s2_1_1_sect1_left.png';
import sect1_right from '../../../../assets/images/s2_1_1_sect1_right.png';

import s2_1_2_sect2_img1 from '../../../../assets/images/s2_1_2_sect2_img1.png';
import s2_1_2_sect2_img2 from '../../../../assets/images/s2_1_2_sect2_img2.png';
import s2_1_2_sect2_img3 from '../../../../assets/images/s2_1_2_sect2_img3.png';

import s2_1_2_sect3_img from '../../../../assets/images/s2_1_2_sect3_img.png';

import ProductSlider from '../../common/ProductSlider';
import FixedButton from '../../common/FixedButton';
import GoContact from '../../common/GoContact';

export default function Content() {
  return (
    <>
      <GoContact />
      <div className="s2_1_1_sect2 pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">특징</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">강력한 성능의 T8</p>
        </div>
        <div className="center">
          <div className="col-flex mb-5">
            <div className="row-flex-center between mb-4 m-col-flex ">
              <div className="s2_1_1_sect2_item w-48">
                <img src={s2_1_2_sect2_img1} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3">
                  컴팩트하고 뛰어난 이동성
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  55cm의 좁은 공간도 자유자재로 이동.
                </p>
              </div>
            </div>

            <div className="row-flex-center between mb-10 m-col-flex">
              <div className="s2_1_1_sect2_item w-48 pc-none t-none ">
                <img src={s2_1_2_sect2_img2} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  스마트한 셀프픽업 기능*
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  T8 DINERBOT은 트레이 감지 센서와 300º 범위의 개폐형 트레이를
                  <br className='t-none'/>
                  장착하고 있습니다. 또한, 10.1인치 터치 스크린과 음성 알림을
                  통해   <br className='t-none'/>
                  정확한 셀프 픽업을 유도합니다.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-none">
                <img src={s2_1_2_sect2_img2} alt="" />
              </div>
            </div>

            <div className="row-flex-center between m-col-flex">
              <div className="s2_1_1_sect2_item w-48 ">
                <img src={s2_1_2_sect2_img3} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  다수 로봇간의 동기화
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  다수 로봇을 동기화하여 효율적인 서빙서비스를 제공합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="s2_1_1_sect3 pt-10">
        <div className="center">
          <div className="txt-center mb-4">
            <p className="prt-medium fs-22 fc-005eed  mb-1">제품 사양</p>
            <p className="prt-bold fs-40 fc-black1 lh-13">
              로봇의 상세 스펙을 확인하세요
            </p>
          </div>

          <div className="flex-center mb-4">
            <img src={s2_1_2_sect3_img} alt="" />
          </div>

          <div className="">
            <div className="flex-center col-flex">
              <div className="s2_1_1_sect3_inner w-60 mb-5 m-w-100 t-w-100">
                <div className="row-flex-center between s2_1_1_sect3_inner_box">
                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">제품무게</p>
                    <p className="prt-bold fs-28 fc-black1">34kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">트레이 개수</p>
                    <p className="prt-bold fs-28 fc-black1">3개</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">적재 중량</p>
                    <p className="prt-bold fs-28 fc-black1">20kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">최소 이동폭</p>
                    <p className="prt-bold fs-28 fc-black1">55cm</p>
                  </div>
                </div>
              </div>

              <div className="s2_1_1_sect3_inner2 w-70 mb-10 m-w-100 t-w-100">
                <div
                  className="row-flex between 
              w-100 lh-14 s2_1_1_sect3_inner2_box
              m-col-flex t-col-flex"
                >
                  <div className="left w-48 m-w-100 t-w-100">
                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          제품크기
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          38.4 × 46.8 × 111.1cm <br />
                          (15.12” × 18.43” × 43.74”)
                        </p>
                      </div>
                    </div>

                    <div className="item min-h-85 ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          최대운행속도
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          1.0 m/s (3.28 ft/s)
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          충전시간**
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          T8 LS : 4.5시간 / T8 LS : 4.5시간
                        </p>
                      </div>
                    </div>

                    <div className="item" style={{ paddingBottom: '34px' }}>
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          트레이 사이즈
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          상부 2단 : <br />
                          38.3 × 34.2cm (15.08” × 13.46”)
                          <br className="mb-1" />
                          마지막단 : <br />
                          32.5 × 31.8cm (12.80” × 12.52”)
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="right w-48 m-w-100 t-w-100">
                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          통과 가능 최소 폭
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          T8 LS : 34kg (74.96 Ibs)
                          <br />
                          T8 LS : 38kg (83.78 Ibs)
                        </p>
                      </div>
                    </div>
                    <div className="item min-h-85">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          배터리 수명*
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          T8 LS : 완충시 최대 15시간 <br />
                          T8 LS : 최대 18시간
                        </p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          트레이 개수
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">3</p>
                      </div>
                    </div>

                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          적재중량
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                          20kg (88 Ibs)
                        </p>
                      </div>
                    </div>
                    <div className="item ">
                      <div className="row-flex w-100 between txt-left">
                        <p className="prt-semi-bold fs-20 fc-005eed w-30">
                          최소 이동 폭
                        </p>
                        <p className="prt-semi-bold fs-20 fc-black1 w-70">
                          55cm (21.65”)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sub_desc prt-light fs-14 fc-888 txt-left lh-15">
                  *배터리와 관련된 모든 설명은 기타 다양한 요인에 의해 제약되며,
                  실제 결과는 다를 수 있습니다.
                  <br />
                  배터리 충전 횟수는 제한되어 결국 교체가 필요할 수 있습니다.
                  배터리 수명과 충전횟수는 사용 및 설정에 따라 다릅니다.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProductSlider></ProductSlider>
      <FixedButton></FixedButton>
    </>
  );
}
